<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <!-- 视频开始 -->
  <div class="hbody is-loading">
    <div id="video-container">
      <div class="video-overlay"></div>
      <div class="video-content">
        <div class="landing">
          <!-- Page Wrapper -->
          <div id="page-wrapper">
            <!-- Banner -->
            <section id="banner">
              <div class="inner">
                <h2>华胤集团</h2>
                <p>创世界一流钢结构公司</p>
                <p>为有极致需求的客户提供专业的服务</p>
              </div>
              <a href="javascript:;" class="more scrolly" @click="forId('about')">了解更多</a>
            </section>
          </div>
        </div>
      </div>
      <!--<keep-alive>
        <video autoplay loop muted controlslist="nodownload">
          <source src="@/components/videos/home1.mp4" type="video/mp4" />
          <source src="@/components/videos/home1.webm" type="video/webm" />
        </video>
      </keep-alive>-->
      <keep-alive>
        <img
          src="@/components/videos/Home-1.gif"
          alt=""
          style="height: 100vh; width: 100vw"
        />
      </keep-alive>
    </div>
    <!-- 视频结束 -->
    <!-- 关于开始 -->
    <section id="about">
      <div class="row about-wrap">
        <div class="col-full">
          <div class="about-profile-bg">
            <div class="intro">
              <h3 class="animate-this">华胤简介</h3>
              <p class="lead animate-this" style="text-align: left">
                <span>华胤集团</span>
                始创于1994年，是最早将预制装配式钢结构建筑系统引入中国的外资企业之一
                。品质管理和焊接制造水平获得美国AISC、加拿大CWB、欧盟EN1090、EN-ISO3834、日本JIS、ISO9001、中国钢结构制造企业资质证书（一级）等权威认证。拥有相关专利十多项。总部设在中国上海，旗下包括华胤钢结构工程(昆山)有限公司、华胤钢结构工程(江苏)有限公司、国盛新能源(海安)有限公司、华胤工程股份有限公司（台湾），在北美设有办事处（筹办工厂），在越南、泰国等地设有生产基地。在江苏海安拥有12.5万平米的先进制造厂。业务涵盖钢结构建筑系统设计、制造与施工，光伏电站建设等。产品远销美洲、欧洲、澳洲、非洲等五大洲。企业勇担社会责任，致力于构建良好业态，注重环保及员工的健康与安全。
              </p>
            </div>
          </div>
        </div>
        <!-- end col-full  -->
      </div>
      <!-- end about-wrap  -->
    </section>
    <!-- 关于结束 -->
    <!-- 三大项开始 -->
    <div class="new-scheme-main">
      <p class="title">华胤集团核心服务</p>
      <p class="titleTo">—— MORE ——</p>
      <div class="detail-list">
        <div class="detail">
          <img v-lazy="home1" alt="Lazy-loaded Image" />
          <div class="mask" @click="tohyzz">
            <div class="text">
              <p class="symbol">华胤制造</p>
              <p class="name">FABRICATION</p>
            </div>
          </div>
        </div>
        <div class="detail">
          <img v-lazy="home2" alt="Lazy-loaded Image" />
          <div class="mask" @click="tohyjz">
            <div class="text">
              <p class="symbol">华胤建造</p>
              <p class="name">CONSTRUCTION</p>
            </div>
          </div>
        </div>
        <div class="detail">
          <img v-lazy="home3" alt="Lazy-loaded Image" />
          <div class="mask" @click="tohycz">
            <div class="text">
              <p class="symbol">华胤创造</p>
              <p class="name">ENGINEERING</p>
            </div>
          </div>
        </div>
        <div class="detail">
          <img v-lazy="home4" alt="Lazy-loaded Image" />
          <div class="mask" @click="tohyxny">
            <div class="text">
              <p class="symbol">华胤新能源</p>
              <p class="name">NEW ENERGY</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 三大项结束 -->
     <!-- 五大核心 -->
    <div class="new-scheme-main">
      <p class="title">华胤核心价值</p>
      <p class="titleToNo">—— MORE ——</p>
      <div>
        <ul class="ul">
          <li style="--accent-color:#41516C">
              <div class="date">环境保护</div>
              <div class="title">
                <img v-lazy="home38" alt="Lazy-loaded Image" class="hxImg">
              </div>
              <div class="descr">公司积极承担环境保护责任，实施节能减排、优化资源管理、促进循环利用等措施，减轻自然环境负担。我们鼓励员工参与环保活动，与社会携手合作，共同为保护地球环境做出贡献。</div>
          </li>
          <li style="--accent-color:#FBCA3E">
              <div class="date">社会责任</div>
              <div class="title">
                <img v-lazy="home39" alt="Lazy-loaded Image" class="hxImg">
              </div>
              <div class="descr">社会责任是一个好公司应该主动去做的事情，通过负责任的商业行为，实现环境的可持续发展，尊重人权，促进社区发展，提升品牌美誉度，为可持续发展做出贡献。</div>
          </li>
          <li style="--accent-color:#E24A68">
              <div class="date">关爱员工</div>
              <div class="title">
                <img v-lazy="home40" alt="Lazy-loaded Image" class="hxImg">
              </div>
              <div class="descr">公司通过提供公平薪酬、职业发展、健康安全的工作条件和工作生活平衡，激发员工潜力，增强团队凝聚力，从而吸引和保留人才，推动企业长期成功。</div>
          </li>
          <li style="--accent-color:#1B5F8C">
              <div class="date">重视质量</div>
              <div class="title">
                <img v-lazy="home41" alt="Lazy-loaded Image" class="hxImg">
              </div>
              <div class="descr">企业通过严格的质量控制和持续改进，确保产品和服务超越客户期望，减少浪费，提高效率，降低成本，以保持市场竞争力和品牌优势。</div>
          </li>
          <li style="--accent-color:#4CADAD">
              <div class="date">永续经营</div>
              <div class="title">
                <img v-lazy="home42" alt="Lazy-loaded Image" class="hxImg">
              </div>
              <div class="descr">永续经营是华胤一直追求的方向，这要求企业在追求经济效益的同时，注重环境保护和社会责任，实现环境、经济和社会的可持续性，以保障长期发展和为未来世代负责。</div>
          </li>
      </ul>
      </div>
    </div>
    
    <!-- 项目开始 -->
    <div class="new-scheme-main">
      <p class="title" @click="tocgal" style="cursor: pointer">华胤典型案例</p>
      <p @click="tocgal" class="titleTo">—— MORE ——</p>
      <div class="detail-list"></div>
    </div>
    <!-- 走马灯 -->
    <div class="scrm">
      <!-- 使用swiper -->
      <div class="swiper-container">
        <swiper :options="swiperOption" class="swip">
          <swiper-slide
            v-for="(item, index) in homeImages"
            :key="index"
            class="swiper-slide"
            style="text-align: center; position: relative"
          >
            <div class="overlay">
              <transition name="fade">
                <div class="altitle">{{ item.title }}</div>
              </transition>
              <transition name="fade">
                <div class="text">{{ item.text }}</div>
              </transition>
              <transition name="fade" mode="out-in">
                <div class="details" @click="setCgal(index + 1)">
                  {{ item.details }}
                </div>
              </transition>
            </div>
            <transition name="fade">
              <img :src="item.image" class="swiper-image" />
            </transition>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </div>
    <!-- 项目结束 -->
    <!-- 荣誉开始 -->
    <div class="new-scheme-main">
      <p class="title" @click="tohyry" style="cursor: pointer">华胤集团认证</p>
      <p @click="tohyry" class="titleTo">—— MORE ——</p>
      <div class="detail-list"></div>
    </div>
    <div class="full-screen-portfolio" id="portfolio">
      <div class="container-fluid hidden-xs">
        <div class="col-md-3 col-sm-6">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home5"
                    :preview-src-list="[
                      home5,
                      home6,
                      home7,
                      home8,
                      home9,
                      home10,
                    ]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>中国CQM认证</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home11"
                    :preview-src-list="[home11]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>美国ASIC认证</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home12"
                    :preview-src-list="[home12, home13]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>美国AWS认证</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home14"
                    :preview-src-list="[home14]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>加拿大CWB认证</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home15"
                    :preview-src-list="[home15, home16, home17]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>欧洲Applus认证</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home18"
                    :preview-src-list="[home18, home19]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>中国SGS认证</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home20"
                    :preview-src-list="[home20]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>中国SCS认证</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid visible-xs">
        <div class="col-md-3 col-sm-4 col-xs-4 ryfox">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home31"
                    :preview-src-list="[
                      home5,
                      home6,
                      home7,
                      home8,
                      home9,
                      home10,
                    ]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>CQM认证</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-4 col-xs-4 ryfox">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home32"
                    :preview-src-list="[home11]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>ASIC认证</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-4 col-xs-4 ryfox">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home33"
                    :preview-src-list="[home12, home13]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>AWS认证</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-4 col-xs-4 ryfox">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home34"
                    :preview-src-list="[home14]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>CWB认证</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-4 col-xs-4 ryfox">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home35"
                    :preview-src-list="[home15, home16, home17]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>Applus认证</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-4 col-xs-4 ryfox">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home36"
                    :preview-src-list="[home18, home19]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>SGS认证</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-4 col-xs-4 ryfox">
          <div class="portfolio-item">
            <div class="thumb">
              <div class="image">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 100%"
                    :src="home37"
                    :preview-src-list="[home20]"
                  >
                  </el-image>
                </div>
              </div>
              <div class="hover-effect">
                <div class="hover-content">
                  <h1>SCS认证</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 荣誉结束 -->
</template>

<script>
import $ from 'jquery'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
var imagesLoaded = require('imagesloaded')
import { TweenMax } from 'gsap'
import { TimelineMax } from 'gsap'
import { gsap } from 'gsap'
import { MotionPathPlugin } from 'gsap/MotionPathPlugin'
import { TextPlugin } from 'gsap/TextPlugin'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
export default {
  data() {
    return {
      repla: false,
      home1: require('@/components/img/home/l4.jpg'),
      home2: require('@/components/img/home/l7.jpg'),
      home3: require('@/components/img/home/l1.jpg'),
      home4: require('@/components/img/home/l2.jpg'),
      home5: require('@/components/img/home/image11.png'),
      home6: require('@/components/img/home/image12.png'),
      home7: require('@/components/img/home/image13.png'),
      home8: require('@/components/img/home/image14.png'),
      home9: require('@/components/img/home/image15.png'),
      home10: require('@/components/img/home/image16.png'),
      home11: require('@/components/img/home/image17.png'),
      home12: require('@/components/img/home/image18.png'),
      home13: require('@/components/img/home/image19.png'),
      home14: require('@/components/img/home/image20.png'),
      home15: require('@/components/img/home/image21.png'),
      home16: require('@/components/img/home/image22.png'),
      home17: require('@/components/img/home/image23.png'),
      home18: require('@/components/img/home/image24.png'),
      home19: require('@/components/img/home/image25.png'),
      home20: require('@/components/img/home/image26.png'),
      home31: require('@/components/img/home/image42.png'),
      home32: require('@/components/img/home/image43.png'),
      home33: require('@/components/img/home/image44.png'),
      home34: require('@/components/img/home/image45.png'),
      home35: require('@/components/img/home/image46.png'),
      home36: require('@/components/img/home/image47.png'),
      home37: require('@/components/img/home/image48.png'),
      home38: require('@/components/img/home/hx1.jpg'),
      home39: require('@/components/img/home/hx2.jpg'),
      home40: require('@/components/img/home/hx3.jpg'),
      home41: require('@/components/img/home/hx4.jpg'),
      home42: require('@/components/img/home/hx5.jpg'),

      homeImages: [
        {
          image: require('@/components/img/cgal/al1.jpg'),
          title: '上海惠群广场',
          text: '上海惠群广场，作为城市中的一个现代建筑典范，其设计与结构特点融合了创新与实用，旨在创造一个既符合现代审美又满足功能需求的空间......',
          details: '了解详情',
        },
        {
          image: require('@/components/img/cgal/al2.jpg'),
          title: '厦门银鹭集团',
          text: '银鹭集团是厦门最大的民营食品企业,正有意向工业旅游业发展。因此,结构选材上,既要考虑到当地多台风多雨的气候特点,有要注重整体工程与周边环境的视觉效果......',
          details: '了解详情',
        },
        {
          image: require('@/components/img/cgal/al3.jpg'),
          title: '本田项目汇总',
          text: '4S汽车展示厅是汽车销售、展览、维修与商业办公四大功能汇总一处的总称，它的诞生和林立式汽车业蓬勃发展的一个重要标志。各个品牌在自主设计上风格各有千秋，但主体结构却有规律可寻......',
          details: '了解详情',
        },
        {
          image: require('@/components/img/cgal/al4.jpg'),
          title: '阿盖尔国际机场',
          text: '阿盖尔国际机场建在约 275 英亩的土地上，铺砌跑道长 2,743 米（9,000 英尺），宽 45 米（150 英尺）。该机场旨在容纳像波音 747-400 这样的大型喷气式飞机......',
          details: '了解详情',
        },
        {
          image: require('@/components/img/cgal/al5.jpg'),
          title: '孟加拉GF项目',
          text: '孟加拉GF项目坐落于孟加拉国诺尔辛迪县。这个项目可是意义非凡，它由孟加拉政府直接进行投资建设，是保障孟加拉农业稳产增收的标志性项目......',
          details: '了解详情',
        },
        {
          image: require('@/components/img/cgal/al6.jpg'),
          title: '森松VCR加拿大项目',
          text: '森松VCR加拿大项目是一个创新的环保项目，该项目旨在利用先进的电解水制氢技术，将不可回收的废物和残余生物质转化为生物燃料和循环化学品，助力实现可持续发展目标......',
          details: '了解详情',
        },
      ],
      swiperOption: {
        notNextTick: false,
        // pagination: {
        //     el: '.swiper-pagination',
        //     clickable: true
        // },
        loop: true,
        touchRatio: 2, // 触摸滑动的顺畅度
        initialSlide: 1, // 默认展示页
        autoplay: true, // 是否自动播放
        speed: 2000, // 播放速度
        slidesPerView: 'auto',
        centeredSlides: true,
        paginationClickable: true,
        spaceBetween: 5, // 模块之间的间隔
        on: {
          slideChangeTransitionEnd: function () {
            // 处理手动操作轮播图后后不再自动轮播
            this.autoplay.start()
          },
        },
        // 如果你需要导航按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          hideOnClick: false, //点击slide时显示/隐藏按钮。BUG处理：如果遇到无效，可增加样式 .swiper-container .swiper-button-hidden{ opacity : 0; }
          disabledClass: 'my-button-disabled', //前进后退按钮不可用时的类名。
          hiddenClass: 'my-button-hidden', //按钮隐藏时的Class
        },
      },
      showTitle: [],
      showDetails: [],
    }
  },
  components: {
    swiper,
    swiperSlide,
  },
  mounted() {
    this.startAnimation()
    this.repla = true
    $(document).ready(function ($) {
      'use strict'

      $(function () {
        // Vars
        var modBtn = $('#modBtn'),
          modal = $('#modal'),
          close = modal.find('.close-btn img'),
          modContent = modal.find('.modal-content')
        
        var $window = $(window);
        var $body =$('.hbody');

          // 添加 'is-loading' 类
          // $body.addClass('is-loading');

          // 当从缓存中恢复时移除 'is-loading' 类
          if (sessionStorage.getItem('pageWasCached')) {
            sessionStorage.removeItem('pageWasCached');
            window.setTimeout(function() {
              $body.removeClass('is-loading');
            }, 100);
          }

          // 页面加载时设置标志，以便在下次恢复时移除 'is-loading' 类
          sessionStorage.setItem('pageWasCached', true);

          // 监听 'load' 事件，处理页面首次加载的情况
          $(window).on('load', function() {
            window.setTimeout(function() {
              $body.removeClass('is-loading');
            }, 100);
          });


// 
        /*// 使用on()方法绑定滚动事件
                  $window.on("scroll", function() {
                    // 在滚动事件处理程序中执行代码
                    var scrollTop = $(window).scrollTop();
                    console.log("滚动位置：" + scrollTop);
                });*/
        $window.on('scroll', function () {
          // 获取可视窗口的顶部和底部位置
          var windowHeight = $(window).height()
          var scrollTop = $(window).scrollTop()
          var scrollBottom = scrollTop + windowHeight

          // 循环检查每个内容元素是否在可视窗口内
          $('#about .about-wrap').each(function () {
            var elementTop = $(this).offset().top
            var elementBottom = elementTop + $(this).outerHeight()
            // 如果内容元素出现在可视窗口内，应用酷炫的 CSS3 动画
            if (elementTop < scrollBottom && elementBottom > scrollTop) {
              $(this).css({
                animation: 'fadeInFromLeft 1s ease both',
              })
            }
          })
          $('#services .services-content').each(function () {
            var elementTop = $(this).offset().top
            var elementBottom = elementTop + $(this).outerHeight()
            // 如果内容元素出现在可视窗口内，应用酷炫的 CSS3 动画
            if (elementTop < scrollBottom && elementBottom > scrollTop) {
              $(this).addClass('animate__animated animate__zoomIn')
            }
          })
          $('#services .col-full').each(function () {
            var elementTop = $(this).offset().top
            var elementBottom = elementTop + $(this).outerHeight()
            // 如果内容元素出现在可视窗口内，应用酷炫的 CSS3 动画
            if (elementTop < scrollBottom && elementBottom > scrollTop) {
              $(this).addClass('animate__animated animate__slideInDown')
            }
          })
          $('.new-scheme-main .detail').each(function () {
            var elementTop = $(this).offset().top
            var elementBottom = elementTop + $(this).outerHeight()
            // 如果内容元素出现在可视窗口内，应用酷炫的 CSS3 动画
            if (elementTop < scrollBottom && elementBottom > scrollTop) {
              $(this).addClass('animate__animated animate__fadeIn')
            }
          })
          $('.slideshow').each(function () {
            var elementTop = $(this).offset().top
            var elementBottom = elementTop + $(this).outerHeight()
            // 如果内容元素出现在可视窗口内，应用酷炫的 CSS3 动画
            if (elementTop < scrollBottom && elementBottom > scrollTop) {
              $(this).addClass('animate__animated animate__fadeInLeft')
            }
          })
          $('#portfolio .portfolio-item').each(function () {
            var elementTop = $(this).offset().top
            var elementBottom = elementTop + $(this).outerHeight()
            // 如果内容元素出现在可视窗口内，应用酷炫的 CSS3 动画
            if (elementTop < scrollBottom && elementBottom > scrollTop) {
              $(this).addClass('animate__animated animate__fadeIn')
            }
          })
        })

        // 初始化时触发一次滚动事件，以显示可视区域内的内容
        $(window).trigger('scroll')
        // open modal when click on open modal button
        modBtn.on('click', function () {
          modal.css('display', 'block')
          modContent
            .removeClass('modal-animated-out')
            .addClass('modal-animated-in')
        })

        // close modal when click on close button or somewhere out the modal content
        $(document).on('click', function (e) {
          var target = $(e.target)
          if (target.is(modal) || target.is(close)) {
            modContent
              .removeClass('modal-animated-in')
              .addClass('modal-animated-out')
              .delay(300)
              .queue(function (next) {
                modal.css('display', 'none')
                next()
              })
          }
        })
      })

      // on click event on all anchors with a class of scrollTo
      $('a.scrollTo').on('click', function () {
        // data-scrollTo = section scrolling to name
        var scrollTo = $(this).attr('data-scrollTo')

        // toggle active class on and off. added 1/24/17
        $('a.scrollTo').each(function () {
          if (scrollTo == $(this).attr('data-scrollTo')) {
            $(this).addClass('active')
          } else {
            $(this).removeClass('active')
          }
        })

        // animate and scroll to the sectin
        $('.hbody, html').animate(
          {
            // the magic - scroll to section
            scrollTop: $('#' + scrollTo).offset().top,
          },
          1000
        )
        return false
      })
    })
    gsap.registerPlugin(MotionPathPlugin, TextPlugin, ScrollToPlugin)
    // provide jQuery argument
    imagesLoaded.makeJQueryPlugin($)
    $('.slideshow')
      .imagesLoaded({ background: true })
      .done(function () {
        // hide loader
        $('.loader').addClass('is-loaded')

        // init variables
        var slideshow = $('.slideshow'),
          navigation = $('.navigation'),
          navigationItem = $('.navigation-item'),
          detailItem = $('.detail-item'),
          rotation,
          type = '_short'

        // prepare letters
        $('.headline').each(function () {
          // eslint-disable-next-line no-control-regex
          $(this).html(
            $(this)
              .text()
              // eslint-disable-next-line no-control-regex
              .replace(/([^\x00-\x80]|\w)/g, "<span class='letter'>$&</span>")
          )
        })

        // prepare navigation and set navigation items on the right place
        navigationItem.each(function (index, elem) {
          TweenMax.set(elem, {
            left: navigation.width() / 2 - navigationItem.width() / 2 - 10,
            rotation: 90 + (index * 360) / navigationItem.length,
            transformOrigin: '50% ' + navigation.width() / 2 + 'px',
          })
          TweenMax.set($(elem).find('.rotate-holder'), {
            text: String((index * 360) / navigationItem.length),
          })
          TweenMax.set($(elem).find('.background-holder'), {
            rotation: -90 - (index * 360) / navigationItem.length,
          })
        })

        // set tween values
        function setTweenValues() {
          rotation = Number($(this).find('.rotate-holder').text())
        }

        // do tween
        function doTween(target) {
          var timeline = new TimelineMax()

          // add/remove class "active" from navigation & detail
          navigationItem.each(function () {
            $(this).removeClass('active')
            if ($(this).index() == $(target).index()) {
              $(this).addClass('active')
            }
          })
          detailItem.each(function () {
            $(this).removeClass('active')
            if ($(this).index() == $(target).index()) {
              $(this).addClass('active')
            }
          })

          timeline
            .to(navigation, 0.6, {
              rotation: -rotation + type,
              transformOrigin: '50% 50%',
            })
            .staggerTo(
              navigationItem.find('.background-holder'),
              0.6,
              {
                //function that returns a value
                rotation: function (index, element) {
                  return (
                    -90 -
                    Number($(element).prev('.rotate-holder').text()) +
                    rotation +
                    type
                  )
                },
                transformOrigin: '50% 50%',
              },
              0,
              '-=0.6'
            )
            .staggerFromTo(
              $('.active').find('.letter'),
              0.3,
              {
                autoAlpha: 0,
                x: -100,
              },
              {
                autoAlpha: 1,
                x: 0,
              },
              0.025,
              '-=0.3'
            )
            .fromTo(
              $('.active').find('.background'),
              0.9,
              {
                autoAlpha: 0,
                x: -100,
              },
              {
                autoAlpha: 1,
                x: 0,
              },
              0.05,
              '+=0.3'
            )
        }

        // click/hover on items
        navigationItem.on('mouseenter', setTweenValues)
        navigationItem.on('click', function () {
          doTween($(this))
        })

        // on load show slideshow as well as first "active" navigation/detail item
        TweenMax.to(slideshow, 1, { autoAlpha: 1 })
        TweenMax.to($('.active').find('.letter'), 0.7, { autoAlpha: 1, x: 0 })
        TweenMax.to($('.active').find('.background'), 0.7, {
          autoAlpha: 1,
          x: 0,
        })
      })

    // fast fix for resize window and refresh view, attention: not use in production, only for demo purposes!
    ;(function () {
      var width = window.innerWidth

      window.addEventListener('resize', function () {
        if (window.innerWidth !== width) {
          window.location.reload(true)
        }
      })
    })()
  },
  methods: {
    // 调用全局方法，滚动指定id
    forId(tId) {
      this.$store.dispatch('toID', tId);
    },
    //开始走马灯动画
    startAnimation() {
      this.homeImages.forEach((_, index) => {
        setTimeout(() => {
          this.showTitle[index] = true
        }, index * 1000) // 每隔1秒显示下一张图片的标题

        setTimeout(() => {
          this.showDetails[index] = true
        }, (index + 1) * 1000) // 每隔1秒显示下一张图片的详情
      })
    },
    // 华胤制造
    tohyzz() {
      this.$router.push('/hyzz')
      location.reload();
    },
    // 华胤建造
    tohyjz() {
      this.$router.push('/hyjz')
        location.reload();
    },
    // 华胤创造
    tohycz() {
      this.$router.push('/hycz')
        location.reload();
    },
    // 华胤新能源
    tohyxny(){
      this.$router.push('/hyxny')
        location.reload();
    },
    // 成功案例
    tocgal() {
      this.$router.push('/cgal')
        location.reload();
    },
    //华胤荣誉
    tohyry() {
      this.$router.push({
        path: '/gyhyen',
        hash: '#gsry',
      })
      location.reload()
    },
    //成功案例
    setCgal(index) {
      this.$router.push({ path: '/cgal', query: { num: index } })
    },
  },
}
</script>

<style scoped>
@import url('./css/demo.css');
@import url('./css/fontAwesome.css');
@import url('./css/light-box.css');
@import url('./css/templatemo-style.css');
.titleTo {
  font-size: 15px;
  color: #ccc;
  text-align: center;
  margin: 20px 0 -30px 0;
  cursor: pointer;
}
@media screen and (max-width: 736px) {
  .full-screen-portfolio .portfolio-item h1 {
    font-size: 14px;
  }
}
.scrm {
  padding: 0 20px;
}
.swiper-container {
  width: 100%;
  height: 70vh;
  position: relative;
}

.swiper-slide {
  text-align: center;
  position: relative;
}

.overlay {
  position: absolute;
  top: 10%;
  left: 10%;
  width: 20vw;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 20px;
  border-radius: 10px;
  color: white;
}

.altitle {
  font-size: 30px;
  font-family: 微软雅黑;
  margin-bottom: 10px;
}
.text {
  font-size: 16px;
  font-family: 微软雅黑;
  margin: 10px 0;
}
.details {
  font-size: 20px;
  font-family: 微软雅黑;
  background-color: rgba(255, 255, 255, 0.3);
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  z-index: 999;
}

.swiper-image {
  width: 90vw;
  height: 70vh;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.swip {
  height: 70vh;
}
@media screen and (max-width: 736px) {
  .swiper-container {
    width: 100%;
    height: 300px;
    position: relative;
  }
  .swip {
    height: 300px;
  }
  .swiper-image {
    width: 100vw;
    height: 300px;
  }
  .overlay {
    position: absolute;
    top: auto;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    padding: 5px;
    border-radius: 10px;
    color: white;
  }
  .altitle {
    font-size: 15px;
    font-family: 微软雅黑;
    margin-bottom: 10px;
  }
  .text {
    font-size: 10px;
    font-family: 微软雅黑;
    margin: 10px 0;
  }
  .details {
    font-size: 12px;
    font-family: 微软雅黑;
    background-color: rgba(255, 255, 255, 0.3);
    padding: 5px;
    border-radius: 5px;
    cursor: pointer;
  }
  .scrm {
    padding: 0 5px;
  }
  .ryfox {
    padding: 0 2px;
  }
  .hover-content h1 {
    margin: 10px 0;
  }
}
/* 五大核心 */
/* *,
*::before,
*::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
} */
:root{
    --color: rgba(30, 30, 30);
    --bgColor: rgba(245, 245, 245);
}
 
.container {
     
    min-height: 100vh;
    display: grid;
    align-content: center;
    gap: 2rem;
    padding: 2rem;
    font-family: "Poppins", sans-serif;
    color: var(--color);
    background: var(--bgColor);
}
 
h1 {
    text-align: center;
}
 
.ul {
    --col-gap: 2rem;
    --row-gap: 2rem;
    --line-w: 0.25rem;
    display: grid;
    grid-template-columns: var(--line-w) 1fr;
    grid-auto-columns: max-content;
    column-gap: var(--col-gap);
    list-style: none;
    width: 90vw;
    margin-inline: auto;
}
 
.hxImg{
  padding: 5px;
  height: 20vh;
  width: 100%;
}

/* line */
.ul::before {
    content: "";
    grid-column: 1;
    grid-row: 1 / span 20;
    background: rgb(225, 225, 225);
    border-radius: calc(var(--line-w) / 2);
}
 
/* columns*/
 
/* row gaps */
.ul li:not(:last-child) {
    margin-bottom: var(--row-gap);
}
 
/* card */
.ul li {
    grid-column: 2;
    --inlineP: 1.5rem;
    margin-inline: var(--inlineP);
    grid-row: span 2;
    display: grid;
    grid-template-rows: min-content min-content min-content;
}
 
/* date */
.ul li .date {
    --dateH: 5rem;
    height: var(--dateH);
    margin-inline: calc(var(--inlineP) * -1);
 
    text-align: center;
    background-color: var(--accent-color);
 
    color: white;
    font-size: 2.25rem;
    font-weight: 700;
 
    display: grid;
    place-content: center;
    position: relative;
 
    border-radius: calc(var(--dateH) / 2) 0 0 calc(var(--dateH) / 2);
}
 
/* date flap */
.ul li .date::before {
    content: "";
    width: var(--inlineP);
    aspect-ratio: 1;
    background: var(--accent-color);
    background-image: linear-gradient(rgba(0, 0, 0, 0.2) 100%, transparent);
    position: absolute;
    top: 100%;
 
    clip-path: polygon(0 0, 100% 0, 0 100%);
    right: 0;
}
 
/* circle */
.ul li .date::after {
    content: "";
    position: absolute;
    width: 2rem;
    aspect-ratio: 1;
    background: var(--bgColor);
    border: 0.3rem solid var(--accent-color);
    border-radius: 50%;
    top: 50%;
 
    transform: translate(50%, -50%);
    right: calc(100% + var(--col-gap) + var(--line-w) / 2);
}
 
/* title descr */
.ul li .title,
.ul li .descr {
    background: var(--bgColor);
    position: relative;
    padding-inline: 1.5rem;
}
 
.ul li .title {
    overflow: hidden;
    padding-block-start: 1.5rem;
    padding-block-end: 1rem;
    font-weight: 500;
    text-align: center;
}
 
.ul li .descr {
    color: #000;
    padding-block-end: 1.5rem;
    font-weight: 300;
    font-size: 14px;
    font-family: "等线 Light";
}
 
/* shadows */
.ul li .title::before,
.ul li .descr::before {
    content: "";
    position: absolute;
    width: 90%;
    height: 0.5rem;
    background: rgba(0, 0, 0, 0.5);
    left: 50%;
    border-radius: 50%;
    filter: blur(4px);
    transform: translate(-50%, 50%);
}
 
.ul li .title::before {
    bottom: calc(100% + 0.125rem);
}
 
.ul li .descr::before {
    z-index: -1;
    bottom: 0.25rem;
}
 
@media (min-width: 40rem) {
    .ul {
        grid-template-columns: 1fr var(--line-w) 1fr;
    }
 
    .ul::before {
        grid-column: 2;
    }
 
    .ul li:nth-child(odd) {
        grid-column: 1;
    }
 
    .ul li:nth-child(even) {
        grid-column: 3;
    }
 
    /* start second card */
    .ul li:nth-child(2) {
        grid-row: 2/4;
    }
 
    .ul li:nth-child(odd) .date::before {
        clip-path: polygon(0 0, 100% 0, 100% 100%);
        left: 0;
    }
 
    .ul li:nth-child(odd) .date::after {
        transform: translate(-50%, -50%);
        left: calc(100% + var(--col-gap) + var(--line-w) / 2);
    }
 
    .ul li:nth-child(odd) .date {
        border-radius: 0 calc(var(--dateH) / 2) calc(var(--dateH) / 2) 0;
    }
    .hxImg{
      padding: 10px 20px;
      height: 35vh;
      width: 100%;
    }
    .ul li .descr{
      font-size: 18px;
    }
}
.titleToNo{
  font-size: 15px;
  color: #ccc;
  text-align: center;
  margin: 20px 0;
  cursor: pointer;
}
</style>
